<template>
  <a class="skip-link" href="#main">Skip to main content</a>
  <div class="container">
    <header>
      <hgroup>
          <h1><router-link to="/">Raymond Rhys Heredia</router-link></h1>
          <p>Web Developer</p>
      </hgroup>
  </header>
  <nav :class="{ open: menuOpen }">
    <button
      type="button"
      class="nav-toggle"
      aria-controls="main-nav"
      :aria-expanded="menuOpen"
      @click="menuOpen = !menuOpen"
    >
      <span class="nav-toggle-icon" aria-hidden="true"></span>
      Menu
    </button>
    <ul id="main-nav">
      <li><router-link to="/">Home</router-link></li>
      <li><router-link to="/about">About</router-link></li>
      <li><router-link to="/blog">Blog</router-link></li>
      <li><router-link to="/portfolio">Portfolio</router-link></li>
      <li><router-link to="/resume">Résumé</router-link></li>
      <li><router-link to="/contact">Contact</router-link></li>
    </ul>
  </nav>
  <main id="main" ref="main" tabindex="-1">
    <router-view/>
  </main>
  <FooterComponent />
  </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';
export default {
  components: {
    FooterComponent,
  },
  data() {
    return { menuOpen: false };
  },
  watch: {
    $route(to, from) {
      // close the mobile menu after navigating
      this.menuOpen = false;
      // skip the initial page load; on later navigations move focus to the
      // new page content so screen readers announce it
      if (!from.matched.length) return;
      this.$nextTick(() => this.$refs.main.focus({ preventScroll: true }));
    }
  }
};
</script>
